/** Klikk og hent (spec 2.3): stored choice, cart sync. Fails open; off with a blank token. */
(() => {
  'use strict';
  if (window.bjerveHenting) return;
  const KEY = 'bjerve-henting';
  let cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('bjerve-henting-data').textContent) || {};
  } catch (e) {}
  const shops = Array.isArray(cfg.butikker) ? cfg.butikker : [];
  const ids = shops.map((s) => s && s.id).filter((id) => /^\d+$/.test(id));
  const token = typeof cfg.token === 'string' ? cfg.token.trim() : '';
  const mods = cfg.moduler || {};

  const valid = (o) => {
    const id = o && o.locationId;
    const known = ids.includes(id);
    if (o && (o.mode === 'henting' ? known : o.mode === 'hjem' && (id === null || known))) return { mode: o.mode, locationId: id };
    return null;
  };
  const read = () => {
    try {
      return valid(JSON.parse(localStorage.getItem(KEY)));
    } catch (e) {
      return null;
    }
  };

  const st = (window.bjerveHenting = { mode: null, locationId: null, status: 'ingen', tid: null, velg, apneVelger });

  function set(c, announce) {
    st.mode = c ? c.mode : null;
    st.locationId = c ? c.locationId : null;
    const html = document.documentElement.classList;
    html.toggle('bjerve-henting-valgt', st.mode === 'henting' && !!token);
    html.toggle('bjerve-hentebutikk', !!st.locationId && !!token);
    if (announce) document.dispatchEvent(new CustomEvent('bjerve-henting:endret', { detail: { mode: st.mode, locationId: st.locationId } }));
    if (token) mount();
  }

  // Cart blocks; cards once a shop is stored (A18).
  let kort;
  const lost = (m) => () => console.warn(`bjerve-henting: ${m} ble ikke lastet`);
  function mount() {
    for (const el of document.querySelectorAll('[data-bjerve-hentekurv]:not([data-montert])')) {
      if (el.closest('cart-drawer:not(.active)')) continue;
      el.setAttribute('data-montert', '');
      import(mods.lager).then((m) => m.mountCart(el, token), lost('lagermodulen'));
    }
    if (!kort && st.locationId && document.getElementById('product-grid')) {
      kort = import(mods.kort).then((m) => m.start(mods.lager, token)).catch(lost('kortmodulen'));
    }
  }

  function velg(mode, id) {
    const c = valid({ mode, locationId: mode === 'hjem' ? st.locationId : id });
    if (!c) return false;
    try {
      localStorage.setItem(KEY, JSON.stringify(c));
    } catch (e) {} // refused: this view only
    set(c, 1);
    schedule();
    return true;
  }

  function apneVelger(o) {
    if (mods.velger) {
      import(mods.velger).then(
        (m) => m.apne(Object.assign({ butikker: shops, valgt: st.locationId, tekst: cfg.tekst || {}, velg, postnummer: mods.postnummer }, o)),
        lost('velgeren')
      );
    }
  }

  let timer;
  let running = null;
  let again = false;
  let later = false;
  const last = () => !later && !again;
  function run() {
    clearTimeout(timer);
    later = false;
    if (running) {
      again = true;
      return running;
    }
    st.status = 'venter';
    running = import(mods.lager)
      .then((m) => m.syncCart(st.mode, st.locationId, token), () => Promise.reject(new Error('modul')))
      .then(
        (r) => {
          if (last()) {
            st.status = r.status;
            st.tid = r.tid;
          }
        },
        (e) => {
          if (last()) st.status = 'feilet';
          console.warn(`bjerve-henting: hentevalget ble ikke lagret, status ${e.message}`);
        }
      )
      .then(() => {
        running = null;
        if (again) {
          again = false;
          return run();
        }
      });
    return running;
  }
  function schedule() {
    if (token && st.mode) {
      clearTimeout(timer);
      st.status = 'venter';
      later = true;
      timer = setTimeout(run, 300);
    }
  }

  const isAdd = (u) => {
    try {
      return /\/cart\/add(\.js)?$/.test(new URL(String(u), location.href).pathname);
    } catch (e) {
      return false;
    }
  };
  const nf = window.fetch;
  window.fetch = function (input) {
    const r = nf.apply(this, arguments);
    if (isAdd((input && input.url) || input)) r.then((x) => x.ok && schedule(), () => {});
    return r;
  };
  const open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (isAdd(u)) this.addEventListener('loadend', () => this.status > 199 && this.status < 300 && schedule());
    return open.apply(this, arguments);
  };

  // Checkout waits <= 2 500 ms, continues once; re-armed if cancelled or after 5 s.
  let leaving = 0;
  let sent;
  const same = (x, y, ...a) => a.every((n) => x.getAttribute(n) === y.getAttribute(n));
  document.addEventListener('submit', (e) => {
    const b = e.submitter;
    const form = e.target;
    if (leaving === 'go') return void (sent = e);
    if (!b || b.name !== 'checkout' || !form.requestSubmit) return;
    if (leaving) return e.preventDefault();
    if (!token || !st.mode) return;
    e.preventDefault();
    const w = (leaving = {});
    const go = () => {
      if (leaving !== w) return;
      leaving = 'go';
      sent = null;
      try {
        const f = form.isConnected ? form : document.getElementById(form.id);
        const s = b.form === f ? b : [...f.elements].find((c) => c.name === 'checkout' && same(c, b, 'formaction', 'formmethod', 'formtarget'));
        if (s && same(f, form, 'action', 'method', 'target')) f.requestSubmit(s);
      } catch (e) {} // gone: re-arm
      const g = (leaving = sent && !sent.defaultPrevented ? {} : 0);
      if (g) setTimeout(() => leaving === g && (leaving = 0), 5e3);
    };
    run().then(go);
    setTimeout(go, 2500);
  }, true);

  addEventListener('storage', (e) => {
    if (e.key === KEY || e.key === null) set(read(), 1);
  });
  addEventListener('pageshow', (e) => {
    if (e.persisted) {
      leaving = 0;
      set(read(), 1);
    }
  });
  if (token) {
    const mo = new MutationObserver(mount);
    mo.observe(document.body, { childList: true, subtree: true });
    for (const d of document.querySelectorAll('cart-drawer')) mo.observe(d, { attributeFilter: ['class'] });
  }
  set(read());
})();
